import { usePlants, useLocations } from '../../../hooks';
import { useAppContext } from '../../../providers';

import QRCode from 'react-qr-code';

import * as classes from './RequestBarcode.module.css';

/**
 * Request Barcode molecule
 * @param {Local.RequestBarcodeProps} props - Component props
 */
export const RequestBarcode = ({ ref, input, action }) => {
  const { selectedPlant, selectedLocation } = useAppContext();

  const { data: plants } = usePlants(true);
  const { data: locations } = useLocations(true);

  const plant = plants?.find((p) => p.id === selectedPlant);
  const location = locations?.find((l) => l.id === selectedLocation);

  return (
    <div ref={ref}>
      <div data-testid='request-barcode' className={classes.container}>
        <div className={classes.title}>Production Request</div>
        <div className={classes.barcode}>
          <QRCode value={JSON.stringify(input)} size={256} />
        </div>
        <div className={classes.details}>
          {plant?.description} - {location?.description}
          <div>
            {action.description} - {action.message}
          </div>
          {input.comment && <div>{input.comment}</div>}
          {input.dropDownListVal1 && <div>List 1: {input.dropDownListVal1}</div>}
          {input.dropDownListVal2 && <div>List 2: {input.dropDownListVal2}</div>}
          {input.dynamicInput && action.actionPrompt && (
            <div>
              {action.actionPrompt}: {input.dynamicInput}
            </div>
          )}
          {input.requestQty && <div>Quantity: {input.requestQty}</div>}
        </div>
      </div>
    </div>
  );
};
